import { match } from '@/utils/pattern-match-util'
import type {
  BookkeepingAccessMethod,
  BookkeepingManagerAction,
} from './BookkeepingPendingAction'

export function formatBookkeepingAccessMethod(
  accessMethod: BookkeepingAccessMethod,
): string {
  return match(accessMethod, {
    Managed: () => 'Firm To Taxfyle to Pro',
    Unmanaged: () => 'Firm to Pro',
    Unspecified: () => 'Unspecified',
  })
}

export function formatBookkeepingManagerAction(
  action: BookkeepingManagerAction,
): string {
  return match(action, {
    ConfirmAccess: () => 'Confirm Access',
    Unspecified: () => 'Unspecified',
  })
}
